import { h, Component } from 'preact';
import style from './style';

import TmplIntro from '../spareparts/templates/intro';
import PlayerLayout from '../playerLayout';
import OTTPreview from '../ottPreview';
import { constants, links } from './../config';
import * as Helper from './../helper';

const swiperJS = links.swiperJS;
const swiperCSS = links.swiperCSS;

const HEAD = document.getElementsByTagName('head')[0];

export default class OTT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      compressedSlideSize: props.isFacebookAd ? 1 : 1.15,
      expand: false,
      mapsApiLoaded: false,
      ottWrapperBounds: null,
      ready: false,
      showDebugConsole: false,
      dpTagActive: false,
      hasAgeGate: false,
      showOTTPreview: props.hasDirectTag && this.shouldShowOTTPreview(),
      isCollectionsTagWithCustomTheme: '',
    };

    this.activateTag = this.activateTag.bind(this);
    this.deactivateTag = this.deactivateTag.bind(this);
    this.handleSlideChangeEnd = this.handleSlideChangeEnd.bind(this);
    this.updateCustomClassForOTT = this.updateCustomClassForOTT.bind(this);

    this.autoDisplayTagConfig = this.props.json && this.props.json.meta && this.props.json.meta.auto_display;

    try {
      this.user = typeof localStorage !== 'undefined' && localStorage.getItem('user');
      this.user = JSON.parse(this.user);
    } catch (e) {
      console.warn('localStorage is not present');
    }
  }

  componentWillMount() {
    if (this.props.json.tags) {
      let storeLocatorInTags = this.props.json.tags.find((item) => item.settings.category === 11);
      let storeLocatorInOtags = this.props.tags.find((item) => item.settings.category === 11);
      let isStoreLocatorPresent = storeLocatorInTags || storeLocatorInOtags;
      this.loadSwiperJS = Helper.loadJS(swiperJS, HEAD);
      this.loadSwiperCSS = Helper.loadCSS(swiperCSS, HEAD);
      this.initTags = this.setTagsToState();

      const isMultiStorePresent = Helper.isMultiStoresMapRequired(this.props.json.tags) || Helper.isMultiStoresMapRequired(this.props.tags);

      if (isStoreLocatorPresent || isMultiStorePresent) {
        this.initializeGoogleMaps();
      }

      this.ottReadyPromise = Promise.all([this.loadSwiperJS, this.loadSwiperCSS, this.initTags]).then((res) => {
        this.initializeSwiper();
      });
    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (this.props.isMobileDevice !== nextProps.isMobileDevice || this.props.orientation !== nextProps.orientation) {
      setTimeout(() => {
        if (this.swiper) {
          this.swiper.params.slidesPerView = this.getSlidesPerView();
          this.swiper.update(true);
        }

        this.props.removeLoader();
      }, 800);
    }

    this.setTagsToState();

    if (!nextState.expand) {
      let ottWrapperHeight = this.ottWrapper && this.ottWrapper.offsetHeight;
      let ottWrapperWidth = this.ottWrapper && this.ottWrapper.offsetWidth;

      this.setState({
        ottRect: ottWrapperWidth > ottWrapperHeight ? 'ottRect' : 'ottSquare',
      });
    }

    // this.tagId gets set with activateTag method call and gets set to null with deactivateTag---
    if (nextProps.deactivateTag && this.tagId) {
      this.deactivateTag();
    }

    if (nextProps.fullWidthOTT && this.swiper) {
      try {
        this.swiper.update(true);
      } catch (e) {}
    }
  }

  componentDidMount() {
    let ottWrapperHeight = this.ottWrapper && this.ottWrapper.offsetHeight;
    let ottWrapperWidth = this.ottWrapper && this.ottWrapper.offsetWidth;

    if (!this.state.expand) {
      this.setState({
        ottRect: ottWrapperWidth > ottWrapperHeight ? 'ottRect' : 'ottSquare',
      });
    }
  }

  componentWillUnmount() {
    this.swiper.off('onSlideChangeEnd', this.handleSlideChangeEnd);
  }

  render(props, state) {
    let isLandscape = props.orientation === constants.ORIENTATION_LANDSCAPE;
    let transformValue = `translate3d(0, ${props.videoHeight + props.fbContainerHeightOffsetTop}px, 0)`;

    let portraitHeightCollapsed = props.isFacebookApp
      ? props.isFacebookAd
        ? window.innerHeight
        : props.containerHeight - props.videoHeight
      : props.portraitVideo
      ? 0
      : window.innerHeight - props.videoHeight;
    let portraitHeightExpanded = props.isFacebookApp
      ? props.isFacebookAd
        ? state.ottRect
          ? document.body.clientHeight - 22
          : window.innerHeight - 22
        : window.innerHeight
      : `100%`;

    if (props.isFacebookAd && props.os === 'Android') {
      portraitHeightCollapsed = window.innerHeight - props.json.aspect_ratio * window.innerWidth - 22;
      portraitHeightExpanded = window.innerHeight - 22;
    }

    let portraitHeight = state.expand ? portraitHeightExpanded : portraitHeightCollapsed;
    let wrapper = {
      width: '100%',
      height: props.isAd ? '100%' : portraitHeight,
      moztransform: transformValue,
      webkitTransform: transformValue,
      transform: transformValue,
    };

    let directTag = props.tags.find((item) => item.id == props.hasDirectTag);
    let hideCloseTagBtn = !!(props.isFacebookAd || props.noVideo || props.ottOnly) && !!props.deeplinkTagId;
    /**
     * new A/B attribute `endcard_details_mandatory` to DISABLE
     * 1) tag preview on timeline,
     * 2) close buttons on tag details,
     * 3) info icon on screen
     * */
    const custom = this.props.json && this.props.json.custom;
    const customEnforeEndCardEnabled = custom && custom.endcards && custom.endcards.enforceEndCard;
    const meta = this.props.json && this.props.json.meta;
    const hideCloseBtnOnTagDetails =
      !this.props.editorMode && ((meta && meta.endcard_details_mandatory) || customEnforeEndCardEnabled);
    hideCloseTagBtn = !!hideCloseBtnOnTagDetails || hideCloseTagBtn;

    if (state.ready) {
      let wrapperClass = props.displayTag
        ? `ottWrapper enable ${state.expand || isLandscape ? 'expand' : ''}`
        : `ottWrapper ${props.lsCards && props.isAd ? 'midExpand' : ''} ${state.expand ? 'expand' : ''} ${
            state.ottRect
          }`;
      wrapperClass = `${wrapperClass} ${props.ottOnly ? 'ottOnly' : ''} ${props.isAd && !this.state.isCollectionsTagWithCustomTheme ? 'noSplitScreen' : ''}`;

      if (this.props.ageGateActive) {
        wrapperClass = `${wrapperClass} gatesWrapper`;
        // { ...wrapper, transform: 'none', moztransform: 'none', webkitTransform: 'none', opacity: 1, zIndex:5 }
      }

      if (this.props.fullWidthOTT) {
        wrapperClass = `${wrapperClass} fullWidth`;
      }
      if (!isLandscape && !state.expand) {
        wrapperClass = `${wrapperClass} zeroWidth`;
      }

      if (this.state.isCollectionsTagWithCustomTheme) {
        wrapperClass = `${wrapperClass} ${this.state.isCollectionsTagWithCustomTheme}`;
      }

      let hasDecisionPoints = state.tags.some((item) => item.settings.category === 15);
      // if selected tag is Social Share the video won't pause and so we want the ott NOT blocking the player clicks---
      const currTag = (props.selectedTagIndex || props.selectedTagIndex === 0) && state.tags[props.selectedTagIndex];
      const isSocialShareEmotion =
        currTag &&
        currTag.settings &&
        currTag.settings.subcategory &&
        currTag.settings.subcategory[0] &&
        (currTag.settings.subcategory[0].type === 1601 || currTag.settings.subcategory[0].type === 1602);

      if (isSocialShareEmotion) {
        wrapperClass = `${wrapperClass} allowClickThrough`;
      }

      return (
        <div style={wrapper} ref={(node) => (this.ottWrapper = node)} class={wrapperClass}>
          <div class={`ottContainer ${state.tags.length <= 1 ? 'single-tag' : 'multi-tag'}`}>
            {state.showDebugConsole ? (
              <div class={'debugConsole'}>
                {/* <h3>Debug Console</h3> */}
                <div class={'debug-info'}>
                  {/* <p>{`navigator.userAgent: ${navigator.userAgent}`}</p> */}
                  <p>{`isExpanded: ${state.expand}`}</p>
                  <p>{`window.innerHeight: ${window.innerHeight}`}</p>
                  <p>{`window.clientHeight: ${document.body.clientHeight}`}</p>
                  <p>{`portraitHeightCollapsed: ${portraitHeightCollapsed}`}</p>
                  <p>{`portraitHeightExpanded: ${portraitHeightExpanded}`}</p>
                  <p>{`document.body.scrollHeight: ${document.body.scrollHeight}`}</p>
                  <p>{`isFacebookApp: ${props.isFacebookApp}`}</p>
                  <p>{`isFacebookAd: ${props.isFacebookAd}`}</p>
                  {/* <p>{`Tags Length: ${props.json.tags.length}`}</p> */}
                </div>
              </div>
            ) : null}

            <div ref={(c) => (this.swiperContainer = c)} class={'swiper-container'}>
              <div class={`swiper-wrapper  ${state.expand ? 'swiper-no-swiping' : ''}`}>
                {props.json.tags.length >= 1 ? (
                  <div class={'swiper-slide'}>
                    <TmplIntro
                      title={props.json.title}
                      desc={props.json.description}
                      social={props.json.social}
                      tag={props.json.tags[0]}
                      template={props.json.template}
                    />
                  </div>
                ) : null}

                {state.tags &&
                  state.tags.map((item, i) => {
                    let slideType = '';
                    let activeSlide = state.activeSlideSoft === i ? 'active-slide-soft' : '';
                    let swipeBehavior = `${props.isFacebookAd ? 'swiper-no-swiping' : ''}`;
                    let decisionPointsOverride = hasDecisionPoints ? 'override-opacity' : '';
                    let tagColor = item.details && item.details.color;
                    let swiperSlideStyle = { color: tagColor };
                    try {
                      slideType =
                        item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type;
                    } catch (e) {}

                    return (
                      <div
                        class={`swiper-slide slideType_${slideType} ${swipeBehavior} ${activeSlide} ${decisionPointsOverride}`}
                        style={swiperSlideStyle}
                      >
                        <PlayerLayout
                          ref={(c) => (this.playerLayout = c)}
                          key={i}
                          {...props}
                          keyIndex={i}
                          index={!props.isFacebookAd ? i + 1 : i + 1}
                          tag={item}
                          decisionPointSelector={state.decisionPointSelector}
                          ottRect={state.ottRect === 'ottRect'}
                          isActiveSlide={i === state.activeIndex - 1}
                          isExpanded={state.expand}
                          isLandscape={isLandscape}
                          template={props.json.template}
                          activateTag={this.activateTag}
                          deactivateTag={this.deactivateTag}
                          hideCloseTagBtn={hideCloseTagBtn}
                          mapsapi={state.mapsApiLoaded}
                          dpTagActive={state.dpTagActive}
                          shouldDeactivateTag={props.deactivateTag}
                          shouldShowOTTPreview={this.shouldShowOTTPreview}
                          showOTTPreview={this.state.showOTTPreview}
                          updateCustomClassForOTT={this.updateCustomClassForOTT}
                          destroyTag={this.destroyTag}
                        />
                      </div>
                    );
                  })}
              </div>

              {props.isFacebookAd ? (
                <div class={'ottBottomNavi'}>
                  <div
                    class={'swiper-button-left zmdi'}
                    ref={(a) => (this.swiperNaviLeft = a)}
                    onClick={this.prevSlide}
                  ></div>
                  <div class={'swiper-pagination'} ref={(b) => (this.swiperPager = b)} />
                  <div
                    class={'swiper-button-right zmdi'}
                    ref={(c) => (this.swiperNaviRight = c)}
                    onClick={this.nextSlide}
                  ></div>
                </div>
              ) : null}
            </div>
          </div>

          {this.props.ageGateActive &&
            this.props.json.gates.map((gate) => {
              return this.renderGate('TmplParticipationGates', gate);
            })}

          {state.showOTTPreview && directTag && !directTag.details.skip && (
            <OTTPreview
              displayAdClickThroughLink={props.displayAdClickThroughLink}
              unmount={this.unmountPreview}
              tag={directTag}
              eventBus={this.props.eventBus}
              orientation={props.orientation}
              json={this.props.json}
            />
          )}
        </div>
      );
    } else return null;
  }

  fetchLayout = (ns, tmpl) => {
    if (!this[ns]) {
      import(
        /* webpackChunkName: "chunk-[request]" */
        `./../spareparts/templates/${tmpl}`
      ).then((res) => {
        this[ns] = res;
        // this.forceUpdate();
      });
    }
  };

  renderGate = (ns, gate) => {
    const currentVideoTime = Math.floor(this.props.getCurrentTime());
    const gateStartTime = gate.duration && gate.duration.tag_start_time;
    const shouldRenderGate = currentVideoTime >= gateStartTime;
    const isPreviewMode = document.body.classList.contains(constants.PREVIEW_MODE);
    const alreadyChecked = this.user[gate.id] && this.user[gate.id] === constants.AGE_GATE_ACCEPTED && !isPreviewMode;
    if (this[ns] && this[ns].default && shouldRenderGate && !alreadyChecked) {
      const Component = this[ns].default;
      return (
        <Component
          tag={gate}
          logDataEvent={this.props.logDataEvent}
          getCurrentTime={this.props.getCurrentTime}
          setAgeGateActive={this.props.setAgeGateActive}
          eventBus={this.props.eventBus}
          trackEvent={this.props.trackEvent}
        />
      );
    }
  };

  shouldShowOTTPreview = () => {
    const tag = this.props.tags.find((item) => item.id == this.props.hasDirectTag);
    if (tag) {
      let settings = tag.settings;
      let category = settings.category;
      let subcategory = settings.subcategory[0].type;

      if (subcategory === 907 || subcategory === 2002) return false; // click to call
      else if (subcategory === 104) return true; // multistore

      switch (category) {
        case 1: // commerce
        case 7: // contact
        case 8: // booking
        case 10: // games & apps
        case 15: // decision point
          return false;
        case 9: // participation
        case 11: // store locator
        case 12: // offers
        case 14: // showcase 
          return true;
      }
    } else return false;
  };

  setTagsToState = () => {
    return new Promise((resolve, reject) => {
      let tags = this.props.json && this.props.json.tags && JSON.parse(JSON.stringify(this.props.json.tags));
      let decisionPoints = tags && tags.filter((item) => item.settings.category === 15);

      if (decisionPoints && decisionPoints.length) {
        const decisionPointIds = decisionPoints.map((t) => t.id);
        let connectedTags = [].concat(
          ...decisionPoints.map(
            (dp) =>
              dp.details &&
              dp.details.engagements &&
              dp.details.engagements[0] &&
              dp.details.engagements[0].meta &&
              dp.details.engagements[0].meta.map((metaItem) => metaItem.tag)
          )
        );
        for (var i = tags.length - 1; i >= 0; i--) {
          let index = connectedTags.indexOf(tags[i].id);
          // the second condition below skips the decision point tag from splicing out as it can be a connected tag also. So it reads as, splice (remove) a connected tag which is also not a decision tag
          index !== -1 && tags[i].settings.category !== 15 && tags.splice(i, 1);
        }
      }
      let isPreviewMode = document.body.classList.contains(constants.PREVIEW_MODE);

      if (this.props.editorMode && !isPreviewMode) {
        tags = this.props.json && this.props.json.otags && JSON.parse(JSON.stringify(this.props.json.otags));
      }
      // console.log('setTagsToState isPreviewMode', isPreviewMode, this.props.editorMode, tags.length);

      if (this.props.json.gates.length > 0) {
        this.props.json.gates.forEach((gate) => {
          this.fetchLayout('TmplParticipationGates', 'participationGates');
        });
      }
      //---
      this.setState(
        {
          tags,
          hasAgeGate: this.props.json.gates.length > 0,
        },
        () => {
          resolve();
          // console.log({ tags: this.state.tags });
        }
      );
    });
  };

  initializeSwiper() {
    this.setState(
      {
        ready: true,
      },
      () => {
        let slidesPerView = this.getSlidesPerView();
        if (this.swiperContainer) {
          this.swiper = new Swiper(this.swiperContainer, {
            speed: 100,
            slidesPerView,
            spaceBetween: 0,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
            },
            nextButton: this.swiperNaviRight,
            prevButton: this.swiperNaviLeft,
          });

          this.swiper.on('onSlideChangeEnd', this.handleSlideChangeEnd);
        }
        if (this.props.isFacebookAd) {
          this.ottWrapper.style.display = 'none';
          this.ottWrapper.offsetHeight;
          this.ottWrapper.style.display = 'block';
        }
      }
    );
  }

  initializeGoogleMaps() {
    if (!window.google && !window.mapsApiLoading) {
      window.mapsApiLoading = true;
      Helper.loadJS(links.mapsapi, HEAD).then(() => {
        this.setState({
          mapsApiLoaded: true,
        });
      });
    }
  }

  getSlidesPerView() {
    let orientation = this.props.orientation;
    let isLandscape = orientation === constants.ORIENTATION_LANDSCAPE ? true : false;
    // return isLandscape ? 1 : (this.state.expand ? 1 : this.state.compressedSlideSize);
    return isLandscape
      ? this.state.expand
        ? 1
        : this.props.isAd
        ? this.state.tags.length > 1
          ? 1.4
          : 1
        : 1
      : this.state.expand
      ? 1
      : 1.15;
  }

  nextSlide = () => {
    this.swiper.slideNext();
  };

  prevSlide = () => {
    this.swiper.slidePrev();
  };

  handleSlideChangeEnd() {
    this.setState({
      activeIndex: this.swiper.snapIndex,
    });
  }

  setTagIndex(index, toggleLock) {
    if (!this.swiper) return false;
    if (!toggleLock && this.props.editorMode) return false;

    let slideMS = this.props.isFacebookAd || this.props.noVideo ? 0 : 100;
    this.swiper.slideTo(index, slideMS, true);

    if (this.state.activeIndex !== index) {
      setTimeout(() => {
        this.handleSlideChangeEnd();
      }, 200);
    }
  }

  activateTag(index, toggleLock, trackEvent) {
    let tagIndex = this.props.isFacebookAd ? index : index - 1;
    let tags = this.props.json && this.props.json.tags && JSON.parse(JSON.stringify(this.props.json.tags));
    let tag = this.props.json.tags && this.props.json.tags[tagIndex];
    let decisionPoints = tags && tags.filter((item) => item.settings.category === 15);
    let decisionPointsCheck = this.props.editorMode && decisionPoints && decisionPoints.length > 0;
    let isPreviewMode = document.body.classList.contains(constants.PREVIEW_MODE);

    if (decisionPointsCheck) {
      if (!isPreviewMode) {
        tag = this.props.json.otags[tagIndex];
      }

      var dpArr = decisionPoints.map(
        (dp) =>
          dp.details.engagements[0] &&
          dp.details.engagements[0].meta &&
          dp.details.engagements[0].meta.filter((t) => t.tag === tag.id)
      );
      var dpIndex;
      dpArr.some((item, index) => {
        if (item.length) {
          let dpTag = decisionPoints[index];
          let tag = item && item[0];
          this.state.tags.some((t, i) => {
            if (dpTag.id === t.id) {
              dpIndex = i;
              return true;
            }
          });

          return true;
        }
      });
    }

    const isSocialShareEmotion =
      tag &&
      tag.settings &&
      tag.settings.subcategory &&
      tag.settings.subcategory[0] &&
      (tag.settings.subcategory[0].type === 1601 || tag.settings.subcategory[0].type === 1602);
    const isDP =
      tag &&
      tag.settings &&
      tag.settings.subcategory &&
      tag.settings.subcategory[0] &&
      tag.settings.subcategory[0].type === 1502;
    const isDPV2 = isDP && tag.details.engagements && tag.details.engagements[0].dpnative;

    if (!isSocialShareEmotion && !isDPV2) {
      this.props.pauseVideo();
    }

    const isCollectionsTagWithCustomTheme =
      (
        Helper.isCollectionsTag(tag) &&
        tag &&
        tag.details &&
        tag.details.customTheme
      ) || '';

    this.setState(
      {
        expand: Helper.mobileCheck() && this.props.scriptEmbed ? this.props.noVideo : true,
        activeIndex: decisionPointsCheck && isPreviewMode && dpIndex ? dpIndex : index,
        decisionPointSelector:
          decisionPointsCheck && isPreviewMode && dpIndex ? [dpIndex, dpArr[dpIndex] && dpArr[dpIndex][0]] : null,
        isCollectionsTagWithCustomTheme
      },
      () => {
        if (this.swiper) {
          if (this.swiper.params && this.swiper.params.slidesPerView) {
            let isLandscape = this.props.orientation === constants.ORIENTATION_LANDSCAPE;
            let isExpanded = this.state.expand;

            this.swiper.params.slidesPerView = 1;

            // if (isLandscape && isExpanded) {
            // this.swiper.allowSlidePrev = false;
            // this.swiper.allowSlideNext = false;
            // }
          }

          try {
            this.swiper.update(true);
          } catch (e) {}

          this.setTagIndex(decisionPointsCheck && isPreviewMode && dpIndex ? dpIndex + 1 : index, toggleLock);
          this.setState({
            ottWrapperBounds: document.querySelector('.ottWrapper').getBoundingClientRect(),
          });
        }

        if (decisionPoints && decisionPoints.length) {
          tag = this.props.json.tags[tagIndex];
        }

        if (this.autoDisplayTagConfig) {
          const tagAutoDisplayConfig = this.autoDisplayTagConfig.find((item) => item.tag === tag.id);
          if (tagAutoDisplayConfig && tagAutoDisplayConfig.tag && !this.autoDisplayTagAutoCloseTriggered) {
            this.autoDisplayTagAutoCloseTriggered = true;
            this.autoDisplayTagTimeout = setTimeout(() => {
              this.playerLayout.handleTagClose();
            }, (tagAutoDisplayConfig.seconds * 1000));
          }
        }

        //--
        // Since DP handleClose method handles the deactivateTag method call, we send it active tag state so it only fires the close call when the active tag is a DP one---
        const checkDP = decisionPoints.filter((item) => item.id === (tag && tag.id));
        this.setState({ dpTagActive: checkDP.length > 0 });

        if (!this.props.noVideo && !this.tagId) {
          this.tagId = tag && tag.id;
          let objToPost = { tagid: tag && tag.id };
          this.props.postMessage(objToPost);
          // with the dp tag interval call the post message keeps on calling as it sets this.tagId as a valid value and deactivateTag always comes as true so willReceiveProps method always calls the deactivateTag method which sets this.tagId to null and so it gets stuck in loop, so to avoid that we set the player deactivateTag as false---It is required for embed iframe(!noVideo) only as the popover one gets updated on receiving postMessage---
          this.props.setDeactivateTagFalse();
        }

        //---
        if (trackEvent && !this.props.editorMode) {
          let video_title = this.props.json.title;
          let tag_duration = Math.floor(this.props.getCurrentTime());
          let eventDataObj = { tag_duration, video_title };

          // tracker event ---
          // to avoid calling event multiple times---
          let initDuration = this.props.getCurrentTime() - (tag && tag.duration.tag_start_time);
          let tag_duration_changed = initDuration !== this.prevTagDuration;

          if (tag_duration_changed) {
            this.props.trackEvent('ViewContent', tag, eventDataObj);
          }

          this.prevTagDuration = initDuration;
          //---
        }
      }
    );
  }

  deactivateTag(dontPauseVideo) {
    this.setState(
      {
        expand: false,
        isCollectionsTagWithCustomTheme: '',
      },
      () => {
        this.tagId = null;
        let hasVideoEnded = this.props.hasVideoEnded();
        let isPreviewMode = document.body.classList.contains(constants.PREVIEW_MODE);
        if ((!hasVideoEnded && !this.props.editorMode) || (!hasVideoEnded && isPreviewMode)) {
          if (!dontPauseVideo) {
            this.props.playVideo();
          }
        }

        setTimeout(() => {
          if (this.swiper) {
            if (this.swiper.params && this.swiper.params.slidesPerView && !dontPauseVideo) {
              this.swiper.params.slidesPerView = this.getSlidesPerView();
              this.swiper.update(true);
            }
          }
        }, 250);
      }
    );
  }

  activateDirectTag = (tagIndex) => {
    this.ottReadyPromise.then(() => {
      this.activateTag(tagIndex);
    });
  };

  unmountPreview = (e) => {
    this.setState({
      showOTTPreview: false,
    });

    this.playerLayout.logTagOpenEvent(true);
    
    /**
     * for display ads the html will have `previewCallback` function
     * which will be used for preview event trackers
     *  */ 
    window.previewCallback && window.previewCallback();

    e && e.stopPropagation();
  };

  updateCustomClassForOTT = (c) => {
    this.setState({
      customClassForOTT: c
    });
  };

  destroyTag = () => {
    clearTimeout(this.autoDisplayTagTimeout);
    this.props.destroyTag();
  }
}



// WEBPACK FOOTER //
// ./components/ott/index.js